<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <!--Vertical y horizontal-->
          <v-flex xs12 sm8>
            <v-card class="elevation-12">
              <v-tabs
                v-if="!notfound && !loading"
                color="blue"
                dark
                grow
                slider-color="yellow"
              >
                <v-tab ripple :to="'/dashboard/sensors/sensor?id=' + getID">
                  ← Volver
                </v-tab>
                <v-tab ripple :to="'/dashboard/sensors/edit?id=' + getID">
                  Datos
                </v-tab>
                <v-tab ripple :to="'/dashboard/sensors/schedules?id=' + getID">
                  Horarios
                </v-tab>
                <v-tab ripple :to="'/dashboard/sensors/building?id=' + getID">
                  Edificio
                </v-tab>
              </v-tabs>
              <v-toolbar dark color="primary">
                <v-toolbar-title>Horarios definidos</v-toolbar-title>
              </v-toolbar>
              <v-subheader>
                <span>
                  Intervalos de tiempo en los que el sensor
                  <strong style="font-weight: 900;">no</strong> mandará alertas.
                  Los movimientos se seguirán registrando en el sistema.
                </span>
              </v-subheader>
              <v-card-text v-if="loading">
                Cargando...
                <v-progress-linear
                  indeterminate
                  color="blue"
                  class="mb-0"
                ></v-progress-linear>
              </v-card-text>
              <v-alert v-if="notfound" :value="true" type="error" color="red">
                Sensor no encontrado.
              </v-alert>
              <v-card-text v-if="!loading && !notfound">
                <h1>Definir nuevo horario</h1>
                <v-layout row wrap>
                  <v-flex xs11 sm4>
                    <v-select
                      required
                      v-model="select"
                      :items="items"
                      item-text="nombre"
                      item-value="valor"
                      prepend-icon="date_range"
                      label="Selecciona los días de la semana"
                      multiple
                      return-object
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip>
                          <span v-if="item.valor !== 2">{{ item.nombre.charAt(0) }}</span>
                          <span v-if="item.valor === 2">X</span>
                        </v-chip>
                      </template>
                      <template v-slot:prepend-item>
                        <v-list-tile ripple @click="toggle">
                          <v-list-tile-action>
                            <v-icon :color="select.length > 0 ? 'indigo darken-4' : ''">
                              {{ icono }}
                            </v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title>
                              Seleccionar todo
                            </v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-divider class="mt-2"></v-divider>
                      </template>
                    </v-select>
                  </v-flex>
                  <v-spacer />
                  <v-flex xs11 sm3>
                    <v-dialog
                      ref="dialog1"
                      v-model="modal1"
                      :disabled="procesando"
                      :return-value.sync="timeInicio"
                      persistent
                      lazy
                      full-width
                      width="300px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          required
                          v-model="timeInicio"
                          label="Hora de inicio"
                          prepend-icon="access_time"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-toolbar v-if="modal1" dark color="primary">
                        <v-toolbar-title>
                          <v-icon>access_time</v-icon> Hora de inicio
                        </v-toolbar-title>
                      </v-toolbar>
                      <v-time-picker
                        format="24hr"
                        scrollable
                        :disabled="procesando"
                        v-if="modal1"
                        v-model="timeInicio"
                        full-width
                      >
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="modal1 = false">
                          Cancelar
                        </v-btn>
                        <v-btn
                          :disabled="timeInicio === null"
                          flat
                          color="primary"
                          @click="$refs.dialog1.save(timeInicio)"
                        >
                          Guardar
                        </v-btn>
                      </v-time-picker>
                    </v-dialog>
                  </v-flex>
                  <v-spacer />
                  <v-flex xs11 sm3>
                    <v-dialog
                        ref="dialog2"
                        v-model="modal2"
                        :disabled="procesando"
                        :return-value.sync="timeFin"
                        persistent
                        lazy
                        full-width
                        width="300px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                            required
                            v-model="timeFin"
                            label="Hora de fin"
                            prepend-icon="access_time"
                            readonly
                            :rules="[compareSchedules]"
                            v-on="on"
                        ></v-text-field>
                      </template>
                      <v-toolbar v-if="modal2" dark color="primary">
                        <v-toolbar-title>
                          <v-icon>access_time</v-icon> Hora de fin
                        </v-toolbar-title>
                      </v-toolbar>
                      <v-time-picker
                        format="24hr"
                        scrollable
                        :disabled="procesando"
                        v-if="modal2"
                        v-model="timeFin"
                        full-width
                      >
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="modal2 = false">
                          Cancelar
                        </v-btn>
                        <v-btn
                            :disabled="timeFin === null"
                            flat
                            color="primary"
                            @click="$refs.dialog2.save(timeFin)"
                        >
                          Guardar
                        </v-btn>
                      </v-time-picker>
                    </v-dialog>
                  </v-flex>
                </v-layout>
                <v-btn
                    :disabled="select.length === 0 || timeInicio === null || timeFin === null || compareSchedules !== true"
                    :loading="procesando"
                    color="primary"
                    @click="addSchedule"
                >
                  Añadir
                </v-btn>
                <v-alert :value="exito" type="success" dismissible>
                  Intervalo añadido.
                </v-alert>
                <v-layout row wrap>
                  <v-spacer/>
                  <v-flex xs12 sm4>
                    <v-text-field
                        v-model="search"
                        label="Buscar horario..."
                        prepend-inner-icon="search"
                        append-icon="schedule"
                        @click:append="modalSearch = true"
                        single-line
                        clearable
                        mask="time"
                    ></v-text-field>
                  </v-flex>
                  <v-dialog
                      ref="dialogSearch"
                      v-model="modalSearch"
                      :disabled="procesando"
                      :return-value.sync="search"
                      persistent
                      lazy
                      full-width
                      width="300px"
                  >
                    <v-toolbar v-if="modalSearch" dark color="primary">
                      <v-toolbar-title>
                        <v-icon>access_time</v-icon> Buscar hora
                      </v-toolbar-title>
                    </v-toolbar>
                    <v-time-picker
                        format="24hr"
                        scrollable
                        :disabled="procesando"
                        v-if="modalSearch"
                        v-model="timeSearch"
                        full-width
                    >
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="modalSearch = false">
                        Cancelar
                      </v-btn>
                      <v-btn
                          :disabled="timeSearch === null"
                          flat
                          color="primary"
                          @click="$refs.dialogSearch.save(timeSearch)"
                      >
                        Guardar
                      </v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-layout>

                <v-data-table
                    rows-per-page-text="Filas por página:"
                    :rows-per-page-items="rowsPerPageItems"
                    :headers="headers"
                    :items="horarios"
                    :search="busqueda"
                    :loading="loading"
                    item-key="key"
                    class="elevation-1"
                >
                  <template v-slot:no-data>
                    <v-alert v-if="!loading" :value="true" type="warning" color="orange">
                      No hay intervalos guardados
                    </v-alert>
                    <v-alert v-if="loading" :value="true" type="info" color="blue">
                      Cargando...
                    </v-alert>
                  </template>
                  <template v-slot:progress>
                    <v-progress-linear color="blue" indeterminate></v-progress-linear>
                  </template>
                  <template v-slot:items="props">
                    <tr>
                      <td class="text-xs-left">{{ procesarDias(props.item.dias) }}</td>
                      <td class="text-xs-left">{{ props.item.timeInicio }}</td>
                      <td class="text-xs-left">{{ props.item.timeFin }}</td>
                      <td class="justify-center layout px-0">
                        <!-- Botón de borrar -->
                        <v-tooltip bottom color="red">
                          <template v-slot:activator="{ on }">
                            <v-btn
                                flat
                                icon
                                color="red"
                                v-on="on"
                                @click.stop="deleteItem(props.item)"
                            >
                              <v-icon>
                                delete
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>Borrar</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </template>
                  <template v-slot:no-results>
                    <v-alert :value="true" type="error" color="red">
                      No se ha encontrado ningún horario a las {{ busqueda }}.
                    </v-alert>
                  </template>
                  <template v-slot:pageText="props">
                    Filas de {{ props.pageStart }} a {{ props.pageStop }} de
                    {{ props.itemsLength }} totales
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import firebase from "firebase";

let firebaseApp;
if (!firebase.apps.length) {
  firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyBnuZJIuRvweJ_qX4ZEmQCe2cerF92RCz4",
    authDomain: "tfgr-9ed26.firebaseapp.com",
    databaseURL: "https://tfgr-9ed26.firebaseio.com",
    projectId: "tfgr-9ed26",
    storageBucket: "tfgr-9ed26.appspot.com",
    messagingSenderId: "47742064305"
  });
} else {
  firebaseApp = firebase.app();
}
export const db = firebaseApp.database();

//Página para añadir horarios a un sensor
// @group Configurar sensor
export default {
  data() {
    return {
      days: [
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado",
        "domingo"
      ],
      select: [],
      items: [
        { nombre: "Lunes", valor: 0 },
        { nombre: "Martes", valor: 1 },
        { nombre: "Miércoles", valor: 2 },
        { nombre: "Jueves", valor: 3 },
        { nombre: "Viernes", valor: 4 },
        { nombre: "Sábado", valor: 5 },
        { nombre: "Domingo", valor: 6 }
      ],
      selected: [],
      search: "",
      expand: false,
      rowsPerPageItems: [5, 10, 25, { text: "Todos", value: -1 }],
      headers: [
        { text: "Días", align: "left", value: "dias" },
        {
          text: "Hora de inicio",
          align: "left",
          sortable: true,
          value: "timeInicio"
        },
        { text: "Hora de fin", align: "left", value: "timeFin" },
        { text: "Borrar", align: "center", sortable: false }
      ],
      timeInicio: null,
      timeFin: null,
      timeSearch: null,
      modal1: false,
      modal2: false,
      modalSearch: false,
      procesando: false,
      procesandoImagen: false,
      loading: true,
      notfound: false,
      exito: false
    };
  },
  created() {
    this.$bindAsArray(
      "arrayDatos",
      db
        .ref("sensors")
        .orderByChild("key")
        .equalTo(this.getID)
        .limitToFirst(1),
      snap => {
        if (this.arrayDatos.length === 0) {
          this.notfound = true;
        }
        this.loading = false;
      },
      error => {
        if (this.arrayDatos.length === 0) {
          this.notfound = true;
        }
        this.loading = false;
      }
    );
  },
  methods: {
    // @vuese
    // Procesa los días de un horario y los devuelve formateados
    // @arg Días
    procesarDias(dias) {
      if (dias === null || dias === undefined) {
        return "";
      }
      let cadena = "";
      for (let i = 0; i < dias.length; i++) {
        if (i === 0) {
          // Primera palabra con mayúscula
          cadena += this.days[dias[i]].charAt(0).toUpperCase() + this.days[dias[i]].slice(1);
        } else {
          cadena += this.days[dias[i]];
        }
        if (i !== dias.length - 1) {
          cadena += ", ";
        }
      }
      return cadena;
    },
    // @vuese
    // Añade un horario al sensor
    // @arg Días de la semana, hora de inicio y hora de fin
    addSchedule() {
      let self = this;
      this.procesando = true;
      this.exito = false;
      let dias = [];
      for (let i = 0; i < this.select.length; i++) {
        dias.push(this.select[i].valor);
      }
      this.$store
        .dispatch("addSchedule", {
          key: this.getID,
          dias: dias,
          timeInicio: this.timeInicio,
          timeFin: this.timeFin
        })
        .then(function() {
          self.procesando = false;
          self.exito = true;
          self.timeInicio = null;
          self.timeFin = null;
        })
        .catch(error => {
          self.procesando = false;
          self.exito = true;
          self.timeInicio = null;
          self.timeFin = null;
        });
    },
    // @vuese
    // Borra un horario del sensor
    // @arg Item de la lista
    deleteItem(item) {
      this.exito = false;
      if (
        confirm(
          "¿Estás seguro de que quieres borrar el intervalo de " + item.timeInicio + " a " + item.timeFin + "?"
        )
      ) {
        this.$store.dispatch("deleteSchedule", {
          key: this.getID,
          dias: item.dias,
          timeInicio: item.timeInicio,
          timeFin: item.timeFin
        });
      }
    },
    toggle() {
      this.$nextTick(() => {
        if (this.select.length === this.items.length) {
          this.select = [];
        } else {
          this.select = this.items.slice();
        }
      });
    }
  },
  computed: {
    // @vuese
    // Comprueba que la hora de inicio y de fin sean distintas
    compareSchedules() {
      return this.timeFin !== null && this.timeInicio === this.timeFin
        ? "El intervalo debe estar formado por dos horas distintas"
        : true;
    },
    // @vuese
    // Procesa el campo de búsqueda
    // @arg Texto a buscar
    busqueda() {
      if (this.search.length === 0) {
        return "";
      }
      if (this.search.length <= 2) {
        return this.search;
      }else {
        const position = 2;
        return [this.search.slice(0, position), ":", this.search.slice(position)].join('');
      }
    },
    // @vuese
    // Devuelve el parámetro ID del navegador
    getIDParameter() {
      return this.$route.query.id;
    },
    // @vuese
    // Indica si el parámetro ID del navegador existe
    parameterIDExists() {
      if (this.$route.query.id === undefined || this.$route.query.id === null) {
        return false;
      } else {
        return true;
      }
    },
    // @vuese
    // Devuelve la ID del sensor
    getID() {
      if (this.parameterIDExists) {
        return this.getIDParameter;
      } else {
        return "";
      }
    },
    // @vuese
    // Devuelve los horarios del sensor
    horarios() {
      if (
        this.arrayDatos[0] === null ||
        this.arrayDatos[0] === undefined ||
        this.arrayDatos[0].schedules === null ||
        this.arrayDatos[0].schedules === undefined
      ) {
        return [];
      } else {
        return Object.values(this.arrayDatos[0].schedules);
      }
    },
    owner() {
      if (
        this.arrayDatos[0] === null ||
        this.arrayDatos[0] === undefined ||
        this.arrayDatos[0].owner === null ||
        this.arrayDatos[0].owner === undefined
      ) {
        return "";
      } else {
        return this.arrayDatos[0].owner;
      }
    },
    // @vuese
    // Procesa el botón de seleccionar todo
    icono() {
      if (this.select.length === this.items.length) {
        return "check_box";
      }
      if (
        this.select.length > 0 &&
        !(this.select.length === this.items.length)
      ) {
        return "indeterminate_check_box";
      }
      return "check_box_outline_blank";
    }
  }
};
</script>
